import styled from 'styled-components';
import { MAX_Z_INDEX } from '../../../../../../../theme/theme';

export const EntityListPopover = styled.ul(({ theme }) => ({
  position: 'absolute',
  boxShadow: theme.shadows['500'],
  border: `1px solid ${theme.colors.neutral['200']}`,
  borderRadius: theme.radii.medium,
  background: theme.colors.bg,
  boxSizing: 'border-box',
  margin: '6px 0',
  padding: '8px 0',
  zIndex: MAX_Z_INDEX,
  width: '100%',
  listStyleType: 'none',
  maxHeight: 'min(36vh, 370px)',
  overflowY: 'auto',
}));

interface ListItemProps {
  isHighlighted?: boolean;
}

export const ListItem = styled.li<ListItemProps>(({ isHighlighted, theme }) => ({
  textAlign: 'left',
  padding: '8px 16px',
  background: isHighlighted ? theme.colors.neutral['100'] : theme.colors.bg,
  cursor: 'pointer',
  userSelect: 'none',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  gap: 16,

  '&:first-of-type': {
    borderTop: 'none',
  },
}));
